import { observable, action, computed, toJS } from 'mobx';
import { token } from "../../../libs/localStorage";
import _ from 'lodash';
import polyUtil from "polyline-encoded";
import moment from 'moment';

export default class WorkOrderRouteStore {
    stationStore;
    workOrderStatusStore;
    workOrderStore;
    priorityStore;
    maintenanceTypeStore;
    userStore;

    @observable polylines = [];

    constructor({
        stationStore,
        workOrderStatusStore,
        workOrderStore,
        priorityStore,
        maintenanceTypeStore,
        userStore,
    }) {
        this.stationStore = stationStore;
        this.workOrderStatusStore = workOrderStatusStore;
        this.workOrderStore = workOrderStore;
        this.priorityStore = priorityStore;
        this.maintenanceTypeStore = maintenanceTypeStore;
        this.userStore = userStore;
    }

    @action setPolylines = (polylines) => {
        this.polylines = polylines;
    }

    @action populatePolylines (workOrders) {
        const {google} = window;
        const promises = [];

        this.polylines = [];

        Object.keys(workOrders).forEach(async assignedToKey => {
            promises.push(new Promise((resolve, reject) => {
                if(workOrders[assignedToKey] && workOrders[assignedToKey].length > 1) {
                    const waypoints = [];

                    const originWorkOrder = workOrders[assignedToKey][0];
                    const destinationWorkOrder = workOrders[assignedToKey][workOrders[assignedToKey].length - 1];

                    const originStations = originWorkOrder.station;
                    const destinationStations = destinationWorkOrder.station;

                    if(originStations && originStations.length > 0 && destinationStations && destinationStations.length > 0) {

                        const originStation = this.stationStore.findById(originStations[0].id);
                        const otherStationsInOriginWorkOrder = originStations.filter(s => +s.id !== +originStation.id);

                        const destinationStation = this.stationStore.findById(destinationStations[destinationStations.length - 1].id);
                        const otherStationsInDestinationWorkOrder = destinationStations.filter(s => +s.id !== +destinationStation.id);

                        const origin = new google.maps.LatLng(originStation.latitude, originStation.longitude);
                        const destination = new google.maps.LatLng(destinationStation.latitude, destinationStation.longitude);

                        otherStationsInOriginWorkOrder.forEach(s => {
                            const station = this.stationStore.findById(s.id);

                            waypoints.push({location: new google.maps.LatLng(+station.latitude, +station.longitude)})
                        });

                        otherStationsInDestinationWorkOrder.forEach(s => {
                            const station = this.stationStore.findById(s.id);

                            waypoints.push({location: new google.maps.LatLng(+station.latitude, +station.longitude)})
                        })

                        workOrders[assignedToKey].slice(1, workOrders[assignedToKey].length - 1).forEach((workOrder) => {
                            workOrder.station.forEach(s => {
                                const station = this.stationStore.findById(s.id);

                                waypoints.push({location: new google.maps.LatLng(+station.latitude, +station.longitude)})
                            })
                        });

                        var directionsService = new google.maps.DirectionsService();
                        var request = {
                            origin,
                            destination,
                            travelMode: 'DRIVING',
                            waypoints,
                            optimizeWaypoints: true
                        };

                        directionsService.route(request, (result, status) => {
                            if (status == 'OK') {
                                if (result.routes && result.routes[0]) {
                                    resolve({
                                        latLngs: polyUtil.decode(result.routes[0].overview_polyline && result.routes[0].overview_polyline.points ? result.routes[0].overview_polyline.points : result.routes[0].overview_polyline),
                                        color: originWorkOrder.color
                                    });
                                }
                                // directionsRenderer.setDirections(result);
                            } else {
                                resolve();
                            }
                        });
                    } else
                        resolve();
                } else {
                    resolve();
                }
            }))
        });

        Promise.all(promises).then(allRes => {
            this.polylines = toJS(allRes.filter((item) => !!item));
        });
    }
}



// WEBPACK FOOTER //
// ./src/stores/Maintenance/WorkOrder/WorkOrderRouteStore.js